import getConfig from 'next/config';
import { useQuery } from 'react-query';
import { accountService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useAddresses = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return useQuery(
    `${ServerStateKeysEnum.doctorAddresses}`,
    () => {
      return accountService.getDoctorAddresses();
    },
    {
      staleTime: storeRegion === 'APAC' ? 0 : Infinity,
      refetchOnWindowFocus: false,
    }
  );
};
